import { getHttpService } from './HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER } from '@/constants';
// import { Insured, ProductChoice } from '@/types/entities';
interface PaymentDetailsResponse {
    data: PaymentDetails;
}
interface PaymentDetails {
    Iban: string | null;
    Bic: string | null;
    BetaalWijze: {
        Code: string;
        Omschrijving: string;
    };
    BetaalTermijn: {
        Code: string;
        Omschrijving: string;
        Ingangsdatum: string | null;
        PercentageKorting: number;
    };
    Incassodag: number;
    BetaalTermijnMutatie: string | null;
    IsSucces: boolean;
    ErrorCode: string | null;
    StatusCode: number;
    LoginAlsKlantSessieNotActive: boolean;
    Content: string | null;
}
interface LoginInfoResponse {
    data: LoginInfo;
}
interface LoginInfo {
    isVerzekeringnemerIngelogd: boolean;
    loginAlsKlantSessieNietActief: boolean;
    relatienummer: string;
    hasReadOnlyRole: boolean;
}
interface PolicyTermsResponse {
    data: PolicyTerms;
}
interface PolicyTerms {
    additionalPolicyTerms: string;
    corePolicyTerms: {
        categorie: string;
        documentLanguage: string;
        documentTitle: string;
        extension: string;
        file: string;
        fileSize: string;
        label: string[];
        wasEmpty: boolean;
        year: string;
    };
}
interface PolicyTermsArgs {
    kenmerkVergoeding?: string;
    Propositie: string;
}

const HttpService = getHttpService();

const getPaymentDetails = async (): Promise<PaymentDetails> => {
    const path = `/clientcontroller/salesfunnelclient/getbetaalgegevens`;
    const { data } = (await HttpService.get(path)) as PaymentDetailsResponse;
    if (data.IsSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path
        });
    }
    return data;
};
const getLoginInfo = async (): Promise<LoginInfo> => {
    const path = `/clientcontroller/salesfunnelclient/ophalenlogininfo`;
    const { data } = (await HttpService.get(path)) as LoginInfoResponse;
    return data;
};
const getPolicyTerms = async (payload: PolicyTermsArgs): Promise<PolicyTerms> => {
    const path = `/clientcontroller/salesfunnelclient/GetPolicyTerms`;

    const { data } = (await HttpService.post(path, payload)) as PolicyTermsResponse;
    if (!data) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path
        });
    }
    return data;
};
export default {
    getPaymentDetails,
    getLoginInfo,
    getPolicyTerms
};
